import script from "./NewsFeedFullPostSlug.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsFeedFullPostSlug.vue?vue&type=script&setup=true&lang=js"

import "./NewsFeedFullPostSlug.vue?vue&type=style&index=0&id=7034e805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7034e805"]])

export default __exports__